module.exports = __webpack_public_path__ + "img/cover_cathouse_mobile.da137bde.png";